import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@cmsgov/design-system';

// Utils
import { normalizeAddress } from '@utils/normalize/normalizeAddress';

import ConditionalRendering from '@components/common/conditional-rendering/ConditionalRendering';

const PreferencesPageAddressViewer = props => {
    const { mailingAddress, getLinkToDashboard, handleMailingAddressExtension, mailingAddressUpdateAllowed, children } =
        props;

    return (
        <div className="contact-section my-4">
            <div className="contact-section__label p-2">
                <span className="required-true">
                    <FormattedMessage id="common.mailing_address" />
                </span>
            </div>

            <div className="contact-section__info">
                <div className="contact-section__content gap-4">
                    <span data-testid="preferences-mailing-address">{normalizeAddress(mailingAddress)}</span>
                    {mailingAddressUpdateAllowed && (
                        <div className="text-start">
                            <Button
                                className="usa-button gi-button gi-button__outline"
                                onClick={handleMailingAddressExtension}
                            >
                                <FontAwesomeIcon icon="edit" />
                                <FormattedMessage id="ssap.button.change_address" />
                            </Button>
                        </div>
                    )}
                </div>

                <ConditionalRendering isTrue={!mailingAddressUpdateAllowed}>
                    <div className="usa-alert usa-alert--warning">
                        <div className="usa-alert__body">
                            <p className="usa-alert__text">
                                <FormattedMessage
                                    id="preferences_page.report_address_via_application"
                                    values={{
                                        link: getLinkToDashboard(<FormattedMessage id="common.back_to_dashboard" />),
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                </ConditionalRendering>

                {children}
            </div>
        </div>
    );
};

export default PreferencesPageAddressViewer;